export default "__VITE_ASSET__De5sj9tp__"